"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLES = exports.DEFAULT_MAX_RATING = void 0;
var DEFAULT_STYLES = {
  DEFAULT_BACKGROUND: '#4B4FA6',
  DEFAULT_MESSAGE_COLOR: 'secondary',
  DEFAULT_REVIEW_COUNT_COLOR: 'greyDark',
  DEFAULT_FONT_SIZE: 'XSmall',
  DEFAULT_LINE_HEIGHT: 'small',
  DEFAULT_SCORE_CARD_LEFT_COLOR: 'default',
  DEFAULT_SCORE_CARD_RIGHT_COLOR: 'greyLight',
  PRE_REVIEW_COUNT: '(',
  REVIEW_COUNT: ' reviews',
  POST_REVIEW_COUNT: ')',
  SLASH: '/'
};
exports.DEFAULT_STYLES = DEFAULT_STYLES;
var DEFAULT_MAX_RATING = '5';
exports.DEFAULT_MAX_RATING = DEFAULT_MAX_RATING;